import { Layout, Typography } from 'antd';
import React, { useEffect, useState } from 'react';

const { Footer } = Layout;
const { Text } = Typography;

const footerStyle = {
    textAlign: 'center',
    color: '#fff',
    backgroundColor: '#3774B6',
};

const FooterSector = () => {
    const [visitCount, setVisitCount] = useState(0);

    useEffect(() => {
        let visits = localStorage.getItem("visitCount");
        visits = visits ? parseInt(visits) + 1 : 1;
        localStorage.setItem("visitCount", visits);
        setVisitCount(visits);
    }, []);

    return (
        <Footer style={footerStyle}>
            Copyright &copy;2025 - mypropertyscope.com
            <br />
            <Text style={{ fontSize: "10px", opacity: 0.7 }}>Views: {visitCount}</Text>
        </Footer>
    );
};

export default FooterSector;